import { CEAssessmentSummaryAttributesBase } from './ce-assessment-summary-attributes-base'


export class CEAssessmentSummaryAttributes extends CEAssessmentSummaryAttributesBase {

}